/* eslint-disable no-console */
import axios from "axios";
import { acquireToken } from "../auth/authUtils";

const baseUrl = process.env.REACT_APP_BASE_URL;

export const getMetaAccounts = async () => {
  try {
    const accessToken = await acquireToken();

    const response = await axios.get(`${baseUrl}/meta/accounts`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching Meta accounts:", error);
    throw error;
  }
};

export const getMetaFormsByAccountId = async (accountId, pageAccessToken) => {
  if (!accountId) {
    throw new Error("Account ID is required");
  }

  if (!pageAccessToken) {
    throw new Error("Page Access Token is required");
  }

  try {
    const accessToken = await acquireToken();

    const response = await axios.get(`${baseUrl}/meta/accounts/${accountId}/forms`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "X-Page-Access-Token": pageAccessToken,
      },
    });

    return response.data;
  } catch (error) {
    console.error(`Error fetching forms for account ${accountId}:`, error);
    throw error;
  }
};

export const getMetaFormById = async (formId) => {
  if (!formId) {
    throw new Error("Form ID is required");
  }

  try {
    const accessToken = await acquireToken();

    const response = await axios.get(`${baseUrl}/meta/forms/${formId}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error(`Error fetching form with ID ${formId}:`, error);
    throw error;
  }
};
